import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useInternalBorrowerGet } from 'core/types'

import ModelLink from './ModelLink'
type PersonLinkProps = {
  personId: string
}

const PersonLink: FC<PersonLinkProps> = ({ personId }) => {
  const [_, { companyId }] = useQueryApi()
  const { data: person, isLoading } = useInternalBorrowerGet({
    companyId,
    personId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  return <ModelLink id={personId} isLoading={isLoading} model={person} />
}

export default PersonLink
